import { BaseService } from "core/services";
import { FacilityInventoryCalculationItemRouteService } from "application/facility-order/services";

class FacilityInventoryCalculationItemService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new FacilityInventoryCalculationItemRouteService());
	}

	async validateQuantity(id,inventoryCalculationCutbacksQuantity){
        const url = this.routeService.validateQuantity(id,inventoryCalculationCutbacksQuantity);
        const response = await this.apiClient.get(url);
        return response.data;
    }

	updateActualCutbackExtraSuppliesQuantity(resource){
        const url = this.routeService.updateActualCutbackExtraSuppliesQuantity(resource);
        const response = this.apiClient.put(url);
        return response.data;
    }
}

export default FacilityInventoryCalculationItemService;